<template>
  <div id="Site">
    <Header ref="header" @openHelp="onOpenHelp"/>

    <main role="main" id="Main">
      <Scene ref="scene" :style="{ opacity: $route.name == 'game' ? 1 : 0 }" :renderable="isRenderable" @loadCompleted="onLoadSceneCompleted" @openMessage="openMessage" @openIndice="openIndice" @openInteraction="openInteraction"/>
      
      <transition name="fade" appear>
        <Background v-if="$route.name != 'game' || withHelp || withBack" />
      </transition>

      <transition name="scale">
        <Shape :class="{ 'Shape_content': shape == 'content', 'Shape_load': shape == 'load'}" v-if="$route.name == 'home' || $route.name == 'loader'"/>
      </transition>

      <transition name="fade" mode="out-in" appear>
        <router-view ref="currentView" @loadAllCompleted="onLoadAllCompleted" @toggleRender="onToggleRender" @isCompleted="withBack = true"/>
      </transition>

      <transition name="scale">
        <Help ref="help" v-if="withHelp" @closeHelp="withHelp = false" />
      </transition>
    </main>

  </div>
</template>

<script>

import { mapGetters, mapState, mapActions } from 'vuex'

import vhCheck from 'vh-check'

import FastClick from 'fastclick'

import Header from '@/components/partial/Header'
import Shape from '@/components/partial/Shape'
import Background from '@/components/partial/Background'
import Help from '@/components/partial/Help'

import Scene from '@/components/partial/Scene'

import Loader from '@/views/Loader'

export default {
  components: { 
    Loader,
    Header,
    Shape,
    Background,
    Scene,
    Help
  },
  data () {
    return {
      isRenderable: true,
      isLoaded: false,
      cache: null,
      shape: null,
      withHelp: false,
      withBack: false,
      lastRenderState: null
    }
  },
  watch: {
    $route()
    {
      this.checkRoute()
    },
    withHelp()
    {
      if(!this.withHelp)
        this.isRenderable = true
    },
    isRenderable()
    {
      if(this.isRenderable)
        this.$refs.header.withHelp = true
      else
        this.$refs.header.withHelp = false
    }
  },
  methods: {
    ...mapActions([
      'setMousePosition',
      'setScrollTop'
    ]),
    onToggleRender(state)
    {
      this.isRenderable = state
    },
    onOpenHelp()
    {
      this.withHelp = true
      this.isRenderable = false
    },
    openMessage(message)
    {
      this.$refs.currentView.onOpenMessage(message)
    },
    openIndice(slug)
    {
      console.log(this.$refs.currentView)
      this.$refs.currentView.onOpenIndice(slug)
    },
    openInteraction(slug)
    {
      this.$refs.currentView.onOpenInteraction(slug)
    },
    onLoadAllCompleted(files)
    {
      this.cache = files
      this.isRenderable = false
    },
    onLoadSceneCompleted(files)
    {
      if(this.$route.name == 'loader')
        this.$refs.currentView.sceneIsLoaded()
    },
    onResize(){
      this.$nextTick(() => {
        
        vhCheck('vh')
      })
    },
    checkRoute()
    {
      console.log('checkroute', this.$route.name)
      if(this.$route.name == 'home'){
        this.shape = 'content'
        this.isRenderable = false
      }
      if(this.$route.name == 'game'){
        this.isRenderable = true
        this.shape = null
        console.log( this.$refs.scene.startIntro )
        this.$refs.scene.startIntro()
      }
    },
    onResume()
    {
      this.isRenderable = this.lastRenderState
      Howler.mute(false)
    },
    onPause()
    {
      this.lastRenderState = this.isRenderable
      this.isRenderable = false
      Howler.mute(true)
    }
  },
  created()
  {
    this.$router.push('/')
  },
  mounted () {
    if ('addEventListener' in document) {
      document.addEventListener('DOMContentLoaded', () => {
        FastClick.attach(document.body)
      }, false)
    }

    var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && !navigator.userAgent.match('CriOS')
    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
    var isIE = navigator.userAgent.indexOf('MSIE ') > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)
    var isEdge = navigator.userAgent.indexOf('Edge') > 0

    if (isSafari) { document.body.classList.add('safari') }
    if (isFirefox) { document.body.classList.add('firefox') }
    if (isIE) { document.body.classList.add('ie') }
    if (isEdge) { document.body.classList.add('edge') }

    window.addEventListener('resize', this.onResize)
    window.addEventListener('orientationchange', this.onResize)
    this.onResize()

    // ACTIVE MOUSE PARALLAX
    if (this.$tools.isTouchDevice()) {
      window.addEventListener('devicemotion', (e) => {
        const accel = e.accelerationIncludingGravity
        this.setMousePosition({x: accel.x * 200, y: accel.y * 200})
      })
    }
    else {
      window.addEventListener('mousemove', (e) => {
        this.setMousePosition({x: e.clientX, y: e.clientY})
      })
    }

    // // ACTIVE SCROLL
    window.addEventListener('scroll', (e) => {
      const scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)
      this.setScrollTop(scrollTop)
    })

    this.$raf.init()
    this.$scroll.active()

    this.shape = 'load'

    this.sound = new Howl({
      src: ['/assets/sounds/global.mp3'],
      loop: true
    });

    this.sound.play()

    window.addEventListener('blur', this.onPause, false)
    window.addEventListener('focus', this.onResume, false)
  }
}
</script>

<style lang="stylus">
@import url('https://fonts.googleapis.com/css?family=Lato:400,700&display=swap');

@import './styles/variables'

@import './styles/settings'
@import './styles/global'
@import './styles/animations'

// GENERIC
global-reset()
reset-html5()

.Scene

  position fixed
  top 0px
  left 0px
  width 100%
  height 100%

  &_wrapper

    width 100%
    height 100%

</style>
